import React from "react";
import Form from "repoV2/components/common/Form/Form/Form";
import { IExpressInterestFormWrapper } from "./ExpressInterestFormWrapper.interfaces";
import { useExpressInterestFormWrapper } from "./ExpressInterestFormWrapper.utils";

const ExpressInterestFormWrapper = (props: IExpressInterestFormWrapper) => {
    const { children } = props;

    const { defaultValues, handleSubmit, handleError } =
        useExpressInterestFormWrapper();

    return (
        <Form
            onSubmit={handleSubmit}
            mode="onSubmit"
            reValidateMode="onChange"
            defaultValues={defaultValues}
            onError={handleError}
        >
            {children}
        </Form>
    );
};

export default ExpressInterestFormWrapper;
